import content from "../content/etusivu";
import sanityClient from "../lib/sanityClient";
import previewClient from "../lib/previewClient";
import Meta from "../components/Meta";
import OpenToday from "../components/OpenToday";
import HeroSection from "../components/HeroSection";
import siteConfig from "../lib/siteConfig";
import StructuredData from "../components/StructuredData";
import FeaturedServices from "../components/FeaturedServices";
import ContentBlock from "../components/ContentBlock";
import PreviewBanner from "../components/PreviewBanner";
import { getCompanyInfo } from "../lib/queries/getCompanyInfo";
import { getPageContent } from "../lib/queries/getPageContent";
import { getServices } from "../lib/queries/getServices";
import { formatPhoneNumber } from "../components/phoneUtils.js";

export default function Etusivu({
  services,
  companyInfo,
  pageContent,
  preview,
}) {
  //const cleanedNumber = formatPhoneNumber(companyInfo.phone);
  return (
    <>
      <Meta pageContent={pageContent} />
      <StructuredData />
      <div className="" id="content">
        {preview && <PreviewBanner />}
        <section>
          <HeroSection content={pageContent.hero} />
        </section>
        <section className="md:mb-2">
          <div className="sm:flex gap-x-6 bg-brand-secondary p-4 justify-center">
            <div className="mb-3 md:mb-0">
              <OpenToday openingHours={companyInfo.openingHours} />
            </div>
            <div>
              {companyInfo?.phone && (
                <div className="flex items-center gap-2">
                  <div>Ota yhteyttä: </div>
                  <div className="ml-auto sm:ml-0">
                    <a
                      href={`tel:${formatPhoneNumber(companyInfo.phone)}`}
                      className="btn-secondary inline-block"
                    >
                      {companyInfo.phone}
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
        <section className="page-width">
          <FeaturedServices value={pageContent.highlightedServices} />
        </section>
        <section className="page-section">
          <div className="page-width page-content">
            {pageContent.content && (
              <ContentBlock block={pageContent.content[0]} />
            )}
          </div>
        </section>
        <section className="page-section">
          <div className="page-width page-content">
            {pageContent.content && (
              <ContentBlock block={pageContent.content[1]} />
            )}
          </div>
        </section>
        <section className="page-section">
          <div className="page-width page-content">
            <h2 className="section-heading md:text-center">
              {content.newsFromInstagram}
            </h2>
            <div className="md:text-center">
              Seuraa meitä:{" "}
              <a
                className="font-semibold"
                href={companyInfo.socials.instagram}
                rel="noopener noreferrer"
                target="_blank"
              >
                @elainlaakariasemasinni
              </a>
            </div>
            <div>
              <iframe
                src="https://cdn.lightwidget.com/widgets/df98f2176c875c52933f08858f1ec0fc.html"
                scrolling="no"
                className="w-full border-none"
              ></iframe>
            </div>
            <script src="https://cdn.lightwidget.com/widgets/lightwidget.js"></script>
          </div>
        </section>
      </div>
    </>
  );
}

export async function getServerSideProps({ preview = false }) {
  const companyInfoQuery = `*[_type == "companyInfo"][0]`;
  const pageQuery = `*[_type == "page" && slug.current == $slug][0]`;
  const servicesQuery = `*[_type == "service"] | order(_createdAt asc){
    _id,
    title,
    content,
    image,
    summary,
    pricing->{title}
  }`;

  // console.log("🔍 preview mode:", preview);

  const client = preview ? previewClient : sanityClient;
  const [services, companyInfo, pageContent] = await Promise.all([
    getServices(preview),
    getCompanyInfo(preview),
    getPageContent("home", preview),
  ]);
  //console.log(services);
  const highlightedRefs =
    pageContent.highlightedServices?.map((ref) => ref._ref) || [];
  const highlighted = services.filter((service) =>
    highlightedRefs.includes(service._id)
  );
  pageContent.highlightedServices = highlighted;
  //console.log(pageContent.highlightedServices);

  if (!pageContent) {
    return { notFound: true };
  }

  return {
    props: {
      services,
      companyInfo,
      pageContent,
      preview,
    },
  };
}
